<template>
    <div>
      <div class=" row mb-2" >
         <label class="col-sm-4 lh40 text-lr"><i
          v-if=" Data.data.c_priority==='S'"
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
            <div class="col-sm-7 ">
              <el-date-picker @change="dealData"
                  v-model="value" value-format="yyyy-MM-dd HH:mm:ss "
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </div>
      </div>
    </div>
</template>

<script>

export default {
    name: "dateAndTime",
    props: [
        'Data',
    ],
    data() {
        return {
            value: this.Data.data.c_value,

        }
    },
    created() {
    },
    methods: {
      dealData(){
        var list={'start':this.value[0],'end':this.value[1]}
        this.$get_function(this.Data,list)
      },
    }
}
</script>

<style scoped>
/deep/.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}
</style>
